import React, {useEffect, useRef, useState} from "react";
import {UsePermissions} from "../../hooks/usePermissions";
import {Toast} from "primereact/toast";
import {AutoComplete} from "primereact/autocomplete";
import {getClients, getContractByClient, traerInfoFactura} from "../../api/factura.service";
import {ContainerGroupForm} from "../Containers/ContainerGroupForm";
import {arrayNum, convertirModena, formatNumber} from "../../shared/utils/utils";
import {anios, meses} from "../../shared/types/constantes";
import {UseLoader} from "../../hooks/useLoader";
import {SeccionHora} from "./SeccionHora";
import {SeccionEvento} from "./SeccionEvento";

export const SeccionTurnos = () => {
    const [handleLoad] = UseLoader();
    const [permisos] = UsePermissions();
    const toast = useRef(null);
    const [clientes, setClientes] = useState([]);
    const [FilteredCliente, setFilteredCliente] = useState(null);
    const [dataLiquidacion, setDataLiquidacion] = useState({
        factura: {
            cliente_id: "",
            contratomarco_id: "",
            factura_id: "",
            num_factura: "",
            valor_neto: "",
            valor_descuento: "",
            valor_factura: "",
            porcentaje: ""
        },
        liquidacion: "",
        data: []
    });
    const [selectedcliente, setSelectedcliente] = useState({
        id: "",
        nombre: "",
        tipo: ""
    });

    const [selectedContract, setSelectedContract] = useState(null);
    const [contratos, setContratos] = useState([]);
    const [FilteredContratos, setFilteredContratos] = useState(null);

    const initParams = {
        anio: "",
        mes: "",
        periodo: "",
        cliente_id: '',
        contratomarco_id: "",
    };
    const [field, setField] = useState(initParams);
    const periodo = arrayNum(50);

    useEffect(() => {
        getClients().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setClientes(r.data)
        }).catch(r => console.log(r))
        return () => {
            if (clientes.length > 0) {
                setClientes([]);
            }
        };
    }, []);

    useEffect(() => {
        if (selectedcliente.id !== '') {
            getContractByClientPromise(selectedcliente.id)
        }
    }, [selectedcliente.id]);


    const searchContrato = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...contratos];
            } else {
                _filteredCliente = contratos.filter((contrato) => {
                    return contrato.codigo.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredContratos(_filteredCliente);
        }, 250);
    }

    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }

    const itemTemplateContrat = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.codigo}</div>
            </div>
        );
    }

    const getContractByClientPromise = (clienteId) => {
        if (clienteId !== "") {
            getContractByClient({
                cliente_id: clienteId
            }).then(r => {
                if (r.data.length === 0) {
                    setContratos([])
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "No se encontraron contratos para el cliente seleccionado",
                        life: 3000
                    });
                    return
                }

                setContratos(r.data)
            });
        }
    }

   const buscarInfoFacturaReload = async () => {
       try {
           for (let f in field) {
               if (field[f] === '') {
                   if (f === 'anio') f = 'Año';
                   toast.current?.show({
                       severity: 'warn',
                       summary: 'Alerta',
                       detail: `El campo ${f} es obligatorio`,
                       life: 3000
                   });
                   return;
               }
           }
           handleLoad(true);

           const response = await traerInfoFactura(field);
           handleLoad(false);
           if (response.estado !== 200) {
               toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
               return;
           }

           setDataLiquidacion(response.data)

       } catch (e) {
           handleLoad(false);
           console.log(e)
       }
   }


    const buscarInfoFactura = async (e) => {

        e.preventDefault();
        try {
            for (let f in field) {
                if (field[f] === '') {
                    if (f === 'anio') f = 'Año';
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: `El campo ${f} es obligatorio`,
                        life: 3000
                    });
                    return;
                }
            }
            handleLoad(true);

            const response = await traerInfoFactura(field);
                handleLoad(false);
            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }

            setDataLiquidacion(response.data)

        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }

    return (
        <>
            <Toast ref={toast}/>
            <h6 className="title-modal" id="turno">
                Turnos factura
            </h6>
            <div className=" flex flex-wrap items-center  p-4 primary-color">
                {permisos.consultar === 1 && clientes.length > 0 ?
                    <div className={ contratos.length === 0 ? "mt-2 relative px-4 lg:w-4/12" : "mt-2 relative px-4 lg:w-2/12 " }>
                        <AutoComplete value={selectedcliente} suggestions={FilteredCliente}
                                      style={{"width": "100%"}}
                                      completeMethod={searchCliente}
                                      placeholder="Buscador clientes"
                                      size="30"
                                      field="nombre" dropdown itemTemplate={itemTemplate}
                                      onSelect={(e) => setField({...field, cliente_id: e.value.id})}
                                      onChange={(e) => setSelectedcliente(e.value)}/>
                    </div>
                    : ""}

                { permisos.consultar === 1 && selectedcliente.id !== "" && contratos.length > 0  ?
                    <div className=" mt-2 relative lg:w-2/12 px-4">
                    <AutoComplete value={selectedContract} suggestions={FilteredContratos}
                                  completeMethod={searchContrato}
                                  style={{width: "100%"}}
                                  placeholder="Buscador contrato"
                                  size="30"
                                  field="codigo" dropdown itemTemplate={itemTemplateContrat}
                                  onSelect={(e) => setField({...field, contratomarco_id: e.value.id})}
                                  onChange={(e) => setSelectedContract(e.value)}/>
                </div> : ''}

                <div className=" mt-2 relative lg:w-8/12 px-4">
                    <form onSubmit={buscarInfoFactura}>
                        <div className="row">
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form text-white"
                                    htmlFor="anio"
                                >
                                    Año *
                                </label>
                                <select value={field.anio} name="periodo"
                                        className="form-input"
                                        onChange={(e) => setField({...field, anio: e.target.value})}
                                        id="anio">
                                    <option value="">...</option>
                                    {anios.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                </select>

                            </ContainerGroupForm>



                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form text-white"
                                    htmlFor="mes"
                                >
                                    Mes *
                                </label>
                                <select value={field.mes} name="mes"
                                        className="form-input"
                                        onChange={(e) => setField({...field, mes: e.target.value})}
                                        id="periodo">
                                    <option value="">...</option>
                                    {meses.map((p, i) => <option key={i} value={p.value}>{p.name}</option>)}
                                </select>


                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form text-white"
                                    htmlFor="periodo"
                                >
                                    Periodo *
                                </label>
                                <select value={field.periodo} name="periodo"
                                        className="form-input"
                                        onChange={(e) => setField({...field, periodo: e.target.value})}
                                        id="periodo">
                                    <option value="">...</option>
                                    {periodo.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                </select>


                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-3/12">
                                <div className="mt-6 relative w-full px-4">
                                    <button
                                        className="warning-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Buscar
                                    </button>
                                </div>

                            </ContainerGroupForm>
                        </div>
                    </form>
                </div>

            </div>


            <div className=" lg:w-10/12 mt-3 px-4">
                <div className="container-relative">
                    <table className="items-center w-full bg-transparent border-collapse">
                        <thead>
                        <tr>
                            <th
                                className={
                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"
                                }
                            >
                                Nro de Factura
                            </th>
                            <th
                                className={
                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"

                                }
                            >
                                Valor Facturado
                            </th>
                            <th
                                className={
                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"

                                }
                            >
                                Valor Neto
                            </th>
                            <th
                                className={
                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"

                                }
                            >
                                Valor Descuento
                            </th>
                            <th
                                className={
                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"

                                }
                            >
                                Gastos
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="ml-3 font-bold text-blueGray-600">
                                    {dataLiquidacion.factura.num_factura  }
                                </span>
                            </td>
                            <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                <span
                                    className="ml-3 font-bold text-blueGray-600">
                                    {dataLiquidacion.factura.valor_factura !== '' ? convertirModena(dataLiquidacion.factura.valor_factura): ''}
                                </span></td>
                            <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                <span className="ml-3 font-bold text-blueGray-600">
                                    {dataLiquidacion.factura.valor_neto!== '' ?convertirModena(dataLiquidacion.factura.valor_neto): ''}
                                </span>
                            </td>
                            <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                   <span className="ml-3 font-bold text-blueGray-600">
                                    {dataLiquidacion.factura.valor_descuento !== ''? convertirModena(dataLiquidacion.factura.valor_descuento): ''}
                                </span>
                            </td>
                            <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                   <span className="ml-3 font-bold text-blueGray-600">
                                    {dataLiquidacion.factura.porcentaje !== ''? formatNumber(dataLiquidacion.factura.porcentaje, 2)  + "%": ''}
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>


            <div className="container-relative ">
                {selectedcliente.tipo === 'H' && <SeccionHora tipo={dataLiquidacion.liquidacion}  data={dataLiquidacion.data} factura={dataLiquidacion.factura} reload={buscarInfoFacturaReload}/> }
                {selectedcliente.tipo === 'E' && <SeccionEvento tipo={dataLiquidacion.liquidacion}  data={dataLiquidacion.data} factura={dataLiquidacion.factura} reload={buscarInfoFacturaReload}/> }
            </div>
        </>
    );
};
